import { createSlice } from "@reduxjs/toolkit";
import * as _ser from "../_apiHelpers/ClientsApihelper";
import * as _msg from "../../_utilities/message";
import { updateLoader } from "../../_redux/LoaderSlice";
import { updateSnackbar } from "../../_redux/SnackbarSlice";

const initalState = { data: null, message: "" };
const initialSnackbar = { type: "", message: "" };

export const filterClientsSlice = createSlice({
  name: "FilterClients",
  initialState: initalState,
  reducers: {
    filterClientsStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    filterClientsReducer: (state, action) => {
      if (action.payload.status === 200) {
        if (action.payload.data) {
          return {
            ...state,
            data: action.payload.data?.clients,
            message: action.payload.message,
          };
        }
      } else {
        state = { ...state, message: action.payload.message, data: null };
      }
    },
  },
});
export const { filterClientsReducer, filterClientsStartReducer } =
  filterClientsSlice.actions;
export const filterClientsAsync = (keword) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.FilterClients(keword);
  if (res.data?.clients?.length === 0) {
    res.data.clients = null;
  }
  dispatch(updateLoader(false));
  dispatch(filterClientsReducer(res));
  // dispatch(updateSnackbar({ type: res.status === 200 ? "success" : "error", message: res.data.message }));
};

export const getClientsSlice = createSlice({
  name: "GetClients",
  initialState: initalState,
  reducers: {
    getClientsStartReducer: (state, action) => {
      return { ...state, data: null, hiringMangerData: null, summary: null };
    },
    getClientsReducer: (state, action) => {
      if (action.payload.status === 200) {
        if (action.payload.data.clientdashboard) {
          let clientData = action.payload.data?.clientdashboard?.client;
          let hiringManagerData =
            action.payload.data?.clientdashboard?.hiringManger;
          let summary =
            action.payload.data?.clientdashboard?.summary ||
            action.payload.data?.clientdashboard?.summaryCards;
          if (clientData) {
            clientData.status =
              clientData.status === "Active" || clientData.status === "active"
                ? "1"
                : "0";
            clientData["client_id"] = clientData.id;
          }
          return {
            ...state,
            data: clientData,
            hiringMangerData: hiringManagerData,
            summary: summary,
            message: action.payload.message,
          };
        }
      } else {
        state = { ...state, message: action.payload.message, data: null };
      }
    },
  },
});
export const { getClientsReducer, getClientsStartReducer } =
  getClientsSlice.actions;
export const getClientsAsync = (id) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.GetClients(id);
  dispatch(updateLoader(false));
  dispatch(getClientsReducer(res));
  // dispatch(updateSnackbar({ type: res.status === 200 ? "success" : "error", message: res.data.message }));
};

export const getClientJobsSlice = createSlice({
  name: "GetClientJobs",
  initialState: initalState,
  reducers: {
    getClientJobsStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    getClientJobsReducer: (state, action) => {
      if (action.payload.status === 200) {
        if (action.payload.data) {
          return {
            ...state,
            data: action.payload.data,
            message: action.payload.message,
          };
        }
      } else {
        state = { ...state, message: action.payload.message, data: null };
      }
    },
  },
});
export const { getClientJobsReducer, getClientJobsStartReducer } =
  getClientJobsSlice.actions;
export const getClientJobsAsync =
  (id, obj, filterValue) => async (dispatch) => {
    dispatch(updateLoader(true));
    dispatch(updateSnackbar(initialSnackbar));
    const res = await _ser.GetClientJobs(id, obj, filterValue);
    dispatch(updateLoader(false));
    dispatch(getClientJobsReducer(res));
  };

export const addClientsSlice = createSlice({
  name: "AddClients",
  initialState: initalState,
  reducers: {
    addClientsStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    addClientsReducer: (state, action) => {
      if (action.payload.status === 200) {
        if (action.payload.data) {
          return {
            ...state,
            data: action.payload.data?.code,
            message: action.payload.message,
          };
        }
      } else {
        state = { ...state, message: action.payload.message, data: null };
      }
    },
  },
});
export const { addClientsReducer, addClientsStartReducer } =
  addClientsSlice.actions;
export const addClientsAsync = (data) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.AddClients(data);
  dispatch(updateLoader(false));
  dispatch(addClientsReducer(res));
  setTimeout(() => {
    dispatch(
      updateSnackbar({
        type: res.status === 200 && res.data.code === 200 ? "success" : "error",
        message:
          res.status === 200 && res.data.code === 200
            ? _msg.ADDNEWCLIENT_SUCCESS_MSG
            : res.data.message,
      }),
    );
  }, 500);
};

export const editClientsSlice = createSlice({
  name: "EditClients",
  initialState: initalState,
  reducers: {
    editClientsStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    editClientsReducer: (state, action) => {
      if (action.payload.status === 200) {
        if (action.payload.data) {
          return {
            ...state,
            data: action.payload.data?.code,
            message: action.payload.message,
          };
        }
      } else {
        state = { ...state, message: action.payload.message, data: null };
      }
    },
  },
});
export const { editClientsReducer, editClientsStartReducer } =
  editClientsSlice.actions;
export const editClientsAsync = (id, data) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.EditClients(id, data);
  dispatch(updateLoader(false));
  dispatch(editClientsReducer(res));
  setTimeout(() => {
    dispatch(
      updateSnackbar({
        type: res.status === 200 ? "success" : "error",
        message:
          res.status === 200
            ? _msg.UPDATECLIENT_SUCCESS_MSG
            : _msg.UPDATECLIENT_ERROR_MSG,
      }),
    );
  }, 500);
};

export const getClientswithPagingSlice = createSlice({
  name: "GetClientswithPaging",
  initialState: initalState,
  reducers: {
    getClientswithPagingStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    getClientswithPagingReducer: (state, action) => {
      if (action.payload.status === 200) {
        if (action.payload.data) {
          return {
            ...state,
            data: action.payload.data?.clients,
            message: action.payload.message,
          };
        }
      } else {
        state = { ...state, message: action.payload.message, data: null };
      }
    },
  },
});
export const { getClientswithPagingReducer, getClientswithPagingStartReducer } =
  getClientswithPagingSlice.actions;
export const getClientswithPagingAsync =
  (limit, offset, status) => async (dispatch) => {
    dispatch(updateLoader(true));
    dispatch(updateSnackbar(initialSnackbar));
    const res = await _ser.GetClientswithPaging(limit, offset, status);
    dispatch(updateLoader(false));
    dispatch(getClientswithPagingReducer(res));
    if (res.status !== 200) {
      dispatch(updateSnackbar({ type: "error", message: res.clients.message }));
    }
  };

export const getClientswithFieldsSlice = createSlice({
  name: "GetClientswithFields",
  initialState: initalState,
  reducers: {
    getClientswithFieldsStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    getClientswithFieldsReducer: (state, action) => {
      if (action.payload.status === 200) {
        if (action.payload.data) {
          return {
            ...state,
            data: action.payload.data?.clients,
            message: action.payload.message,
          };
        }
      } else {
        state = { ...state, message: action.payload.message, data: null };
      }
    },
  },
});
export const { getClientswithFieldsReducer, getClientswithFieldsStartReducer } =
  getClientswithFieldsSlice.actions;
export const getClientswithFieldsAsync = (fields) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.GetClientswithFields(fields);
  if (res.data?.clients?.length === 0) {
    res.data.clients = null;
  }
  dispatch(updateLoader(false));
  dispatch(getClientswithFieldsReducer(res));
  if (res.status !== 200) {
    dispatch(updateSnackbar({ type: "error", message: res.clients.message }));
  }
};

export const deleteClientsSlice = createSlice({
  name: "DeleteClients",
  initialState: initalState,
  reducers: {
    deleteClientsStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    deleteClientsReducer: (state, action) => {
      if (action.payload.status === 200) {
        if (action.payload.data) {
          return {
            ...state,
            data: action.payload.data?.code,
            message: action.payload.message,
          };
        }
      } else {
        state = { ...state, message: action.payload.message, data: null };
      }
    },
  },
});
export const { deleteClientsReducer, deleteClientsStartReducer } =
  deleteClientsSlice.actions;
export const deleteClientsAsync = (data) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.DeleteClients(data);
  dispatch(updateLoader(false));
  dispatch(deleteClientsReducer(res));
  setTimeout(() => {
    dispatch(
      updateSnackbar({
        type: res.status === 200 ? "success" : "error",
        message: res.data.message,
      }),
    );
  }, 500);
};

export const filterClientsWithPagingSlice = createSlice({
  name: "FilterClientsWithPaging",
  initialState: initalState,
  reducers: {
    filterClientsWithPagingStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    filterClientsWithPagingReducer: (state, action) => {
      if (action.payload.status === 200) {
        if (action.payload.data) {
          return {
            ...state,
            data: action.payload.data?.clients,
            message: action.payload.message,
          };
        }
      } else {
        state = { ...state, message: action.payload.message, data: null };
      }
    },
  },
});
export const {
  filterClientsWithPagingReducer,
  filterClientsWithPagingStartReducer,
} = filterClientsWithPagingSlice.actions;
export const filterClientsWithPagingAsync =
  (limit, offset, filterValue) => async (dispatch) => {
    dispatch(updateLoader(true));
    dispatch(updateSnackbar(initialSnackbar));
    const res = await _ser.FilterClientsWithPaging(limit, offset, filterValue);
    dispatch(updateLoader(false));
    dispatch(filterClientsWithPagingReducer(res));
    // dispatch(updateSnackbar({
    //     type: (res.status === 200) ? "success" : "error",
    //     message: (res.status === 200) ? res.data.message : res.data.message,
    // }));
  };

export const getClientsCommentsSlice = createSlice({
  name: "GetClientsComments",
  initialState: initalState,
  reducers: {
    getClientsCommentsStartReducer: (state, action) => {
      return { ...state, data: null, isLoading: false };
    },
    getClientsCommentsReducer: (state, action) => {
      if (action.payload.status === 200) {
        if (action.payload.data) {
          return {
            ...state,
            data: action.payload.data.auditlogs,
            message: action.payload.data.message,
            isloader: false,
          };
        }
      } else {
        state = {
          ...state,
          message: action.payload.data.message,
          data: null,
          isloader: false,
        };
      }
    },
  },
});
export const { getClientsCommentsReducer, getClientsCommentsStartReducer } =
  getClientsCommentsSlice.actions;
export const getClientsCommentsAsync = (data) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.GetClientsComments(data);
  dispatch(getClientsCommentsReducer(res));
  dispatch(updateLoader(false));
  // dispatch(updateSnackbar({ type: res.status === 200 ? "success" : "error", message: res.data.message }));
};

export const addHiringmanagersSlice = createSlice({
  name: "AddHiringManagers",
  initialState: initalState,
  reducers: {
    addHiringmanagersStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    addHiringmanagersReducer: (state, action) => {
      if (action.payload.status === 200) {
        if (action.payload.data) {
          return {
            ...state,
            data: action.payload.data?.code,
            message: action.payload.message,
          };
        }
      } else {
        state = { ...state, message: action.payload.message, data: null };
      }
    },
  },
});
export const { addHiringmanagersReducer, addHiringmanagersStartReducer } =
  addHiringmanagersSlice.actions;
export const addHiringmanagersAsync = (id, data) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.AddHiringManagers(id, data);
  dispatch(updateLoader(false));
  dispatch(addHiringmanagersReducer(res));
  setTimeout(() => {
    dispatch(
      updateSnackbar({
        type: res.status === 200 && res.data.code === 200 ? "success" : "error",
        message: res.data.message, //res.status === 200 && res.data.code === 200 ? _msg.ADDNEWCLIENT_SUCCESS_MSG :
      }),
    );
  }, 800);
};

export const getHiringmanagersSlice = createSlice({
  name: "GetHiringManagers",
  initialState: initalState,
  reducers: {
    getHiringmanagersStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    getHiringmanagersReducer: (state, action) => {
      if (action.payload.status === 200) {
        if (action.payload.data) {
          return {
            ...state,
            data: action.payload?.data,
            message: action.payload.message,
          };
        }
      } else {
        state = { ...state, message: action.payload.message, data: null };
      }
    },
  },
});
export const { getHiringmanagersReducer, getHiringmanagersStartReducer } =
  getHiringmanagersSlice.actions;
export const getHiringmanagersAsync = (id, query) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.GetHiringManagers(id, query);
  dispatch(updateLoader(false));
  dispatch(getHiringmanagersReducer(res));
};

export const editHiringmanagersSlice = createSlice({
  name: "EditHiringmanagers",
  initialState: initalState,
  reducers: {
    editHiringmanagersStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    editHiringmanagersReducer: (state, action) => {
      if (action.payload.status === 200) {
        if (action.payload?.data) {
          return {
            ...state,
            data: action.payload?.data?.code,
            message: action.payload.message,
          };
        }
      } else {
        state = { ...state, message: action.payload.message, data: null };
      }
    },
  },
});
export const { editHiringmanagersReducer, editHiringmanagersStartReducer } =
  editHiringmanagersSlice.actions;
export const editHiringmanagersAsync =
  (id, data, managerId) => async (dispatch) => {
    dispatch(updateLoader(true));
    dispatch(updateSnackbar(initialSnackbar));
    const res = await _ser.EditHiringManagers(id, data, managerId);
    dispatch(updateLoader(false));
    dispatch(editHiringmanagersReducer(res));
    setTimeout(() => {
      dispatch(
        updateSnackbar({
          type:
            res.status === 200 && res.data.code === 200 ? "success" : "error",
          message: res.data.message,
        }),
      );
    }, 500);
  };

export const deleteHiringmanagersSlice = createSlice({
  name: "DeleteHiringmanagers",
  initialState: initalState,
  reducers: {
    deleteHiringmanagersStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    deleteHiringmanagersReducer: (state, action) => {
      if (action.payload.status === 200) {
        if (action.payload.data) {
          return {
            ...state,
            data: action.payload.data?.code,
            message: action.payload.message,
          };
        }
      } else {
        state = { ...state, message: action.payload.message, data: null };
      }
    },
  },
});
export const { deleteHiringmanagersReducer, deleteHiringmanagersStartReducer } =
  deleteHiringmanagersSlice.actions;
export const deleteHiringmanagersAsync = (id, data) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.DeleteHiringManagers(id, data);
  dispatch(updateLoader(false));
  dispatch(deleteHiringmanagersReducer(res));
  setTimeout(() => {
    dispatch(
      updateSnackbar({
        type: res.status === 200 ? "success" : "error",
        message: res.data.message,
      }),
    );
  }, 0);
};

// end user section
export const addEndClientsSlice = createSlice({
  name: "AddEndClients",
  initialState: initalState,
  reducers: {
    addEndClientsStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    addEndClientsReducer: (state, action) => {
      if (action.payload?.status === 200) {
        if (action.payload.data) {
          return {
            ...state,
            data: action.payload.data?.code,
            message: action.payload.message,
          };
        }
      } else {
        state = { ...state, message: action.payload?.message, data: null };
      }
    },
  },
});
export const { addEndClientsReducer, addEndClientsStartReducer } =
  addEndClientsSlice.actions;
export const addEndClientsAsync = (id, data) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.AddEndClients(id, data);
  dispatch(updateLoader(false));
  dispatch(addEndClientsReducer(res));
  setTimeout(() => {
    dispatch(
      updateSnackbar({
        type: res.status === 200 && res.data.code === 200 ? "success" : "error",
        message: res.data.message, //res.status === 200 && res.data.code === 200 ? _msg.ADDNEWCLIENT_SUCCESS_MSG :
      }),
    );
  }, 800);
};

export const getEndClientsSlice = createSlice({
  name: "GetEndClients",
  initialState: initalState,
  reducers: {
    getEndClientsStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    getEndClientsReducer: (state, action) => {
      if (action.payload?.status === 200) {
        if (action.payload.data) {
          return {
            ...state,
            data: action.payload?.data,
            message: action.payload.message,
          };
        }
      } else {
        state = { ...state, message: action.payload?.message, data: null };
      }
    },
  },
});
export const { getEndClientsReducer, getEndClientsStartReducer } =
  getEndClientsSlice.actions;
export const getEndClientsAsync = (id, query) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.GetEndClients(id, query);
  dispatch(updateLoader(false));
  dispatch(getEndClientsReducer(res));
};

export const editEndClientsSlice = createSlice({
  name: "EditEndClients",
  initialState: initalState,
  reducers: {
    editEndClientsStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    editEndClientsReducer: (state, action) => {
      if (action.payload?.status === 200) {
        if (action.payload?.data) {
          return {
            ...state,
            data: action.payload?.data?.code,
            message: action.payload.message,
          };
        }
      } else {
        state = { ...state, message: action.payload?.message, data: null };
      }
    },
  },
});
export const { editEndClientsReducer, editEndClientsStartReducer } =
  editEndClientsSlice.actions;
export const editEndClientsAsync =
  (id, data, endClientId) => async (dispatch) => {
    dispatch(updateLoader(true));
    dispatch(updateSnackbar(initialSnackbar));
    const res = await _ser.EditEndClients(id, data, endClientId);
    dispatch(updateLoader(false));
    dispatch(editEndClientsReducer(res));
    setTimeout(() => {
      dispatch(
        updateSnackbar({
          type:
            res.status === 200 && res.data.code === 200 ? "success" : "error",
          message: res.data.message,
        }),
      );
    }, 500);
  };

export const deleteEndClientsSlice = createSlice({
  name: "DeleteEndClients",
  initialState: initalState,
  reducers: {
    deleteEndClientsStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    deleteEndClientsReducer: (state, action) => {
      if (action.payload?.status === 200) {
        if (action.payload.data) {
          return {
            ...state,
            data: action.payload.data?.code,
            message: action.payload.message,
          };
        }
      } else {
        state = { ...state, message: action.payload?.message, data: null };
      }
    },
  },
});
export const { deleteEndClientsReducer, deleteEndClientsStartReducer } =
  deleteEndClientsSlice.actions;
export const deleteEndClientsAsync = (id, data) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.DeleteEndClients(id, data);
  dispatch(updateLoader(false));
  dispatch(deleteEndClientsReducer(res));
  setTimeout(() => {
    dispatch(
      updateSnackbar({
        type: res.status === 200 ? "success" : "error",
        message: res.data.message,
      }),
    );
  }, 0);
};
